import React from 'react'
import { Button, Group } from '@mantine/core'
import { useIntl } from 'react-intl'
import { Column } from 'primereact/column'
import usePaginator from '../../../utils/hooks/usePaginator'
import MainCommonView from '../MainCommonView'
import DataTableComp from '../data-table/DataTableComp'
import rowDelete from '../data-table/column-types/rowDelete'
import './viewNotifiedUsers.scss'
import HeaderViewV2 from '../common-header-v2/HeaderViewV2'
import { themeCfg } from '../../../theme/theme.ts'
import AppLegacyButton from '../../../component/common/AppLegacyButton.tsx'

const ViewNotifiedUsers = ({
  notification,
  canAddUser,
  canDeleteUser,
  toggleAddUserToModule,
  handleDelete,
}) => {
  const { formatMessage: msg } = useIntl()

  const { firstRow, limit, onPageChange } = usePaginator(10)

  const handleAddUserNotification = () => {
    toggleAddUserToModule({
      id: notification?._id,
      action: notification?.action,
    })
  }

  const headerOptions = {
    title: msg({ id: notification?.action }),
    handlerHeaderActions: {
      secondaryButton: canAddUser && handleAddUserNotification,
      secondaryButtonText: 'button.add',
      secondaryButtonIcon: 'pi-plus',
    },
  }

  const pagerOptions = {
    firstRow,
    limit,
    onPageChange,
    totalRecords: notification?.users?.length,
  }

  const dataTable = (
    <DataTableComp
      disableAutoheight
      tableOptions={{
        header: (
          <Group
            w="100%"
            justify="space-between"
            p={themeCfg?.default?.padding}
          >
            <Group>{msg({ id: notification?.action })}</Group>
            <AppLegacyButton
              onClick={handleAddUserNotification}
              icon="plus"
              c="white"
              bg="moure-orange"
            >
              {msg({ id: 'button.add' })}
            </AppLegacyButton>
          </Group>
        ),
        value: notification?.users,
        size: 'smal',
      }}
      columns={[
        <Column
          key={Math.random()}
          field="name"
          header={msg({ id: 'name' })}
          sortable
        />,
        <Column
          key={Math.random()}
          field="email"
          header={msg({ id: 'email' })}
        />,
        canDeleteUser && (
          <Column
            key={Math.random()}
            {...rowDelete({
              handleDelete: (rowId) => handleDelete(notification?._id, rowId),
            })}
          />
        ),
      ]}
    />
  )

  return dataTable
}

export default ViewNotifiedUsers
